import { updateTemplate } from "./Common";

export { updateTemplate };
